import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import { TextLink } from "components/actions/Links";
import { AiWebsiteSource } from "components/ai_chat/types";
import { useAiContext } from "lib/providers/AiContextProvider";
import { EventNames, useTracking } from "lib/tracking";
import { createReferenceLinkOpenedEventPayload } from "./tracking";

type Props = {
  source: AiWebsiteSource;
};

export default function WebsiteSource({ source }: Props) {
  const { logEvent } = useTracking();
  const { colors } = useTheme();
  const { resourceId, resourceType, bidId } = useAiContext();

  const handleSourceClick = () => {
    logEvent(
      EventNames.referenceLinkOpened,
      createReferenceLinkOpenedEventPayload({
        source,
        resourceType,
        resourceId,
        bidId,
      }),
    );
  };

  return (
    <Flex column gap={8}>
      <Text bold>{source.title}</Text>
      <Text description color={colors.sysTextSecondary}>
        {source.url}
      </Text>
      <StyledLink to={source.url} targetType="new-tab" onClick={handleSourceClick} noreferrer>
        View source
      </StyledLink>
    </Flex>
  );
}

const StyledLink = styled(TextLink)(({ theme }) => ({
  color: theme.colors.sysPrimaryDefault,
  cursor: "pointer",
}));
